// ─── Liste de valeurs TYPÉES (téléphones / emails) ────────────────
// Plusieurs entrées { id, type, valeur, principal } : chacune a un type
// (mobile/domicile/travail…), une valeur, et l'une est « principale » (⭐).
// Réutilisable ; le parent fournit le catalogue de types et gère l'état.
import React, { useMemo } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { ChoixPuces, LigneSwipe, stylesForm, useUI, useT, confirmerSuppression } from '@mop/core';
import { nouvelIdEntree } from './services/contacts';

export default function ChampsTypes({ titre, entries = [], types, clavier = 'default', placeholder, ajouterLabel, onChange }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const maj = (arr) => onChange?.(arr);
  const setEntry = (id, patch) => maj(entries.map(e => (e.id === id ? { ...e, ...patch } : e)));
  const setPrincipal = (id) => maj(entries.map(e => ({ ...e, principal: e.id === id })));
  const retirer = (id) => maj(entries.filter(e => e.id !== id));
  const ajouter = () => maj([...entries, { id: nouvelIdEntree(), type: types[0].id, valeur: '', principal: entries.length === 0 }]);

  return (
    <View style={{ marginTop: 4 }}>
      <Text style={s.lbl}>{titre}</Text>
      {entries.map(e => (
        <LigneSwipe key={e.id} espacement={8} onSupprimer={() => retirer(e.id)}>
          {/* Appui long : SEUL recours sur le web, ou le swipe n'est pas fiable. */}
          <TouchableOpacity activeOpacity={1} style={[s.bloc, { marginTop: 0 }]}
            onLongPress={() => confirmerSuppression(t('commun.supprimer'), e.valeur || titre, () => retirer(e.id))}>
            <ChoixPuces options={types.map(ty => ({ id: ty.id, label: `${ty.emoji} ${ty.label}` }))}
              value={e.type} onChange={v => setEntry(e.id, { type: v })} />
            <View style={s.ligne}>
              <TouchableOpacity onPress={() => setPrincipal(e.id)} hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}>
                <Text style={{ fontSize: 20, opacity: e.principal ? 1 : 0.45 }}>{e.principal ? '⭐' : '☆'}</Text>
              </TouchableOpacity>
              <TextInput style={[s.input, { flex: 1, marginTop: 0 }]} value={e.valeur}
                onChangeText={v => setEntry(e.id, { valeur: v })} keyboardType={clavier} autoCapitalize="none"
                placeholder={placeholder} placeholderTextColor={UI.faint} />
            </View>
          </TouchableOpacity>
        </LigneSwipe>
      ))}
      <TouchableOpacity style={s.ajouter} activeOpacity={0.7} onPress={ajouter}>
        <Text style={{ color: UI.accent, fontWeight: '700' }}>＋ {ajouterLabel}</Text>
      </TouchableOpacity>
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  ...stylesForm(UI),
  bloc: { marginTop: 8, padding: 10, backgroundColor: UI.card, borderRadius: 12, borderWidth: 0.5, borderColor: UI.border },
  ligne: { flexDirection: 'row', alignItems: 'center', gap: 10, marginTop: 8 },
  ajouter: { paddingVertical: 9, alignItems: 'center', marginTop: 4 },
});
